module.exports = __webpack_public_path__ + "static/media/arrow-right-hover.a41eee5f.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/arrow-right-hover.svg
// module id = 932
// module chunks = 0